export const USER_LOGGED_IN = "userLoggedIn";
export const USER_LOGGED_OUT = "userLoggedOut"
export const KORISNIK_SELECTED = "korisnikSelected";
export const NET_SET = "netSet";

export const AUTO_MODAL_OPENED = "autoModalOpened";
export const AUTO_MODAL_CLOSED = "autoModalClosed";
export const IS_LOADING = "isLoading";
export const IS_NOT_LOADING = "isNotLoading;";
export const TOGGLE_VARIABLE = "toggleVariable";

export const MENU_OPENED = "menuOpened";
export const MENU_CLOSED = "menuClosed"